//Componentes generales
import {useState, useContext,useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import './FormActivoType.css';
import { PRINCIPAL, NAVBARS, COLOR_BOTONES} from '../../constants/colors';

//Contextos
import activoTypeContext from '../../context/activoTypeContex/activoTypeContex';
import activoContext from '../../context/activoContex/activoContex';


/*
    Componente encargado de mostrar el formulario de usuario.
        Donde data es el usuario crear/modificar.
              minimizar es la función encargada de ocultar el dialogo.
              generar es la función del context que guarda el usuario.
              titulo es la que determina que texto mostrar en encabezado del dialogo.
              verficaUser es la función del context que comprueba la licencia por usuario vigente del cliente.
*/
function FormActivoType({ data, setData, minimizar, formDato, datoGuardar, nuevoEditado,
    generar = () => console.log("Generando"), 
    listaUsuarios = []}) {

    const {actualizaractivoList} = useContext(activoContext)
    const atContext = useContext(activoTypeContext);
    const {agregarActivoType, actualizaractivoTypeList, modificarActivoType,eliminarActivoType} = atContext;
    //State de usuario. Si no viene data por parametro significa que es nuevo por lo que se le asigna una estructura.
    const [activoType, setActivoType] = useState((data !== undefined) ? {group: {codTypeActivo: data?.codTypeActivo, nameTypeActivo: data?.nameTypeActivo, descrp:data?.descrp}} : {group: {codTypeActivo: '', nameTypeActivo: ''}, members: []});
   
    //Constante que define el titulo que corresponde si vienen datos por parametros
    // const [titulo, setTitulo] = useState(( data.id !==  undefined) ? 'Agregar' : 'Modificar');
    const [titulo, setTitulo] = useState(nuevoEditado)

    //Funcion de validacion
    const validacion =  () => { 
        const newErrors = {};
        if (activoType.group.codTypeActivo === '' || activoType.group.codTypeActivo === undefined) return newErrors.codigo = 'El código debe ser colocado';
        if (activoType.group.nameTypeActivo === ''|| activoType.group.codTypeActivo === undefined) return newErrors.nombre = 'El nombre debe ser colocado';
        return ''; 
    };

    const handlerGenerar = async () => {
        
        const errorAxi = validacion();

        if (errorAxi === "") {
    
            try {
                const dato = activoType.group;
                const res = await agregarActivoType(dato);
    
                if (res !== null) {
                    Swal.fire({
                        title: `Se guardo un nuevo Tipo de Activo`,
                        icon: 'success',
                        text: `Código: ${res.codTypeActivo} \n Nombre: ${res.nameTypeActivo}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizaractivoList();
                    actualizaractivoTypeList();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el nombre del Tipo de Activo",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                Swal.fire({
                    title:  "Se esta repitiendo el nombre del Tipo de Activo",
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }  
    }

    const handlerModificar = async () => {

        const errorAxi = validacion();

        if (errorAxi === "") {
    
            try {
                const dato = {
                    _id: data.id === undefined ? data._id : data.id,
                    codTypeActivo: activoType.group.codTypeActivo,
                    nameTypeActivo: activoType.group.nameTypeActivo,
                    descrp: activoType.group.descrp 
                }

                await setData(dato);
                const res = await modificarActivoType(dato);

                if (res !== undefined) {
                    Swal.fire({
                        title: `Se modificó el Tipo de Activo`,
                        icon: 'success',
                        text: `Código: ${res.codTypeActivo} \n Nombre: ${res.nameTypeActivo}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    
                    actualizaractivoTypeList();
                    actualizaractivoList();
                    minimizar({...dato, label: res.nameTypeActivo, value:res.nameTypeActivo});
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el nombre del Tipo de Activo",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }  
 
    }

    const handlerEliminar = () => {

        Swal.fire({
            title: `Estas seguro que deseas eliminar este Tipo de Activo?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
              // El usuario hizo clic en "Aceptar"
                const id = data.id
                const resp = await eliminarActivoType(id);
                Swal.fire({
                    title: `Borrado!`,
                    icon: 'success',
                    text: `El Tipo de Activo fue borrado correctamente!`,
                    showConfirmButton: true,
                    allowEnterKey: true
                })
                actualizaractivoTypeList();
                minimizar(null);
            } else if (result.isDismissed) {
             // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo
                minimizar();
            }
            });
    }

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                {titulo} Tipo de Activo
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Código: </div>
                <input  disabled={ titulo === "Modificar"} value={activoType.group.codTypeActivo} className='label-form-group-data' onChange={data => setActivoType({ ...activoType, group: {...activoType.group, codTypeActivo: data.target.value} })} />
            </div>
            
            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={activoType.group.nameTypeActivo} className='label-form-group-data' onChange={data => setActivoType({ ...activoType, group: {...activoType.group, nameTypeActivo: data.target.value} })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Descripción: </div>
                <textarea className='label-form-group-data' value={activoType.group.descrp} onChange={data => setActivoType({ ...activoType, group: {...activoType.group, descrp: data.target.value} })}/>
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={(  titulo !== "Modificar") ? handlerGenerar : handlerModificar }>{titulo}</button>
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )

                }
                
                    
                
                    
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                    <button className='btn-cancel-form-group' onClick={() => minimizar(formDato.tipoActivo)}>Cancelar</button>
                    )
                }
                
                
            </div>
        </div>
    );
}

export default FormActivoType;